export enum ClaimType {
  CLAIM = 'Claim',
  APPROVAL = 'Authorisation',
}
